import { FeaturePermissionsTemplate } from "../../templates/templates";
import { type FeaturePermissions } from "../../types";
import { Components } from "./cells/dropdown/FeatureCell";

interface Props {

    template: FeaturePermissionsTemplate<{}>

    available: boolean

    permissions: FeaturePermissions
    setPermissions?(value: {}): void

    readOnly: boolean

}

export function FeaturePermissions({ permissions, template, available, setPermissions, readOnly }: Props) {

    const Cell = Components[template.type]

    return <Cell
        feature={permissions}
        available={available}
        setPermissions={setPermissions}
        template={template}
        readOnly={readOnly}
    />

}
